import { useCallback, useEffect, useState } from "react"
import { Input } from "../components/form/Input"
import { TextArea } from "../components/form/TextArea";
import { NumberInput } from "../components/form/NumberInput";
import { DropdownSelect } from "../components/form/DropdownSelect";
import { multiPriceOptions, RENT_PRICE_OPTION, rentPriceTypeOptions } from "../constants/priceOptions";
import { PrimaryButton } from "../components/buttons/PrimaryButton";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ImageFileUploadCard, PictureElement } from "../components/editpage/ImageUploader";
import { RentDateSelection } from "../components/editpage/RentDateSelection";
import { DeleteButton } from "../components/buttons/DeleteButton";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { Label } from "../components/form/Label";
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import Switch from "@mui/material/Switch";
import { DatePickerComponent } from "../components/form/DatePickerComponent";
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import Popup from "../components/common/Popup";
import swedbankLogo from '../assets/images/payment/Swedbank_pos.svg';
import lhvLogo from '../assets/images/payment/Lhv-logo.svg';
import { PaymentOption } from "../components/payment/PaymentOption";
import Dropdown, { DropdownOptionItem } from "../components/form/Dropdown";
import { CreateProductModel, CreateProductResponseType, ProductCheckoutModel, ProductEditResponse, ProductListResponse, ProductRemoveStatus, UpdateProductModel } from "../api/requests/interfaces/Product";
import {
    createPost,
    deleteProduct,
    getProductDetails,
    getProductDetailsEdit,
    getTotalAmountOfSubscriptions,
    updateProduct,
    getUserProducts,
    getUserSubscriptionsCount
} from "../api/requests/product";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { InlineInfoBox } from "../components/common/InlineInfoBox";
import { ProductCategory, productCategoryOptions } from '../constants/products';
import {format, isAfter, isBefore, set} from "date-fns";
import { Spinner } from "../components/common/Spinner";
import axios from "axios";
import PaymentMethods from "../components/payment/PaymentForm";
import PaymentForm from "../components/payment/PaymentForm";
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import { Height, TabTwoTone } from "@mui/icons-material";
import { addNotification, NotificationType } from "../store/features/notificationsSlice";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import NotificationHub, { AddFunction } from "../components/common/NotificationHub";
import { CheckoutPricesResponse, PaymentCompletedPagePaymentType } from "../api/requests/interfaces/Payment";
import { addWeeks } from 'date-fns';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Helmet } from "react-helmet-async";
import ReactGA from 'react-ga4';
import { DisplayType, setGlobalLoadingState } from "../store/features/displaySlice";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import HandymanIcon from '@mui/icons-material/Handyman';
import { productCategoryLabelFormatter } from "../utils/productCategoryLabelFormatter";
import {et} from "date-fns/locale";
import crownIcon from "../assets/images/crown.png";

interface ItemFields {
    title: string;
    description: string;
    location: string;
    category: ProductCategory | undefined;
    availableUntilDate?: Date;
    dayPrice?: number;
}
export interface RentPriceValues {
    id: number;
    price: number;
    type: RENT_PRICE_OPTION;
    amount?: number;
}

export enum ItemEditPageTabType {
    EDIT = "EDIT",
    PAYMENT = "PAYMENT"
}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLI_KEY!);

export const ItemEditPage = () => {

    const user = useAppSelector(state => state.auth.user);

    const [searchParams] = useSearchParams();

    const navigate = useNavigate();

    const [editPageType, setEditPageType] = useState<string | null>();
    const [productId, setProductId] = useState<number>();
    const [highlightUntilDate, setHighlightUntilDate] = useState<Date | undefined>(undefined);
    const displayType = useAppSelector((state) => state.display.type);

    useEffect(() => {
        const type = searchParams.get("type"); // Get the 'type' query parameter
        const id = searchParams.get("id"); // Get the 'id' query parameter
        setEditPageType(type);
        id && setProductId(parseInt(id));

        if (type === null) {
            setEditPageType("create");
        }

        if (id && type === "edit") {
            fetchProductDetail(parseInt(id));
        }
    }, [searchParams]);

    useEffect(() => {
        if (editPageType === "create") {
            setItemFields({
                title: '',
                description: '',
                location: '',
                category: undefined,
                availableUntilDate: undefined,
            })
            setProductImages([])
            setProductId(undefined)
            setProductData(undefined)
            setInvalidFields({
                title: false,
                category: false,
                location: false,
                description: false,
                dayPrice: false,
                availableUntilDate: false,
            })
            setPriceHour(0);
            setPriceDay(0);
            setPriceWeek(0);
            setPriceMonth(0);
        }
    }, [editPageType])

    const [itemFields, setItemFields] = useState<ItemFields>({
        title: '',
        description: '',
        location: '',
        category: undefined,
        availableUntilDate: undefined,
    })

    const [productData, setProductData] = useState<ProductListResponse | undefined>()

    const [inx, setInx] = useState(0);
    const [priceValues, setPriceValues] = useState<RentPriceValues[]>([{ id: 0, price: 0, type: RENT_PRICE_OPTION.HOUR }]);
    const authState = useAppSelector((state) => state.auth.user);
    const [postCreateSuccess, setPostCreateSuccess] = useState(false);
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [creatingProductLoading, setCreatingProductLoading] = useState(false);
    const [redirectedToPayment, setRedirectedToPayment] = useState(false);
    const [showPaymentBox, setShowPaymentBox] = useState(false);
    const [savedOrderId, setSavedOrderId] = useState<number | undefined>(undefined);
    const [savedProductId, setSavedProductId] = useState<number | undefined>(undefined);
    const [stripeClientSecret, setStripeClientSecret] = useState<string | undefined>(undefined);
    const [tabType, setTabType] = useState<ItemEditPageTabType>(ItemEditPageTabType.EDIT);
    const [loadingPaymentSession, setLoadingPaymentSession] = useState(false);
    const dispatch = useAppDispatch();

    const [originalActiveUntilDate, setOriginalActiveUntilDate] = useState<Date>();

    const [priceHour, setPriceHour] = useState(Number);
    const [priceDay, setPriceDay] = useState(0);
    const [priceWeek, setPriceWeek] = useState(Number);
    const [priceMonth, setPriceMonth] = useState(Number);

    const [fileIds, setFileIds] = useState<number[]>([]);
    const [productImages, setProductImages] = useState<PictureElement[]>([])

    const { pathname } = useLocation();

    const [useExactUntilDate, setUseExactUntilDate] = useState(false);

    const [selectedPaymentOption, setSelectedPaymentOption] = useState<string | undefined>(undefined);

    const [boostOption, setBoostOption] = useState<number | undefined>();
    const [productUntilOption, setProductUntilOption] = useState<number | undefined>(2);

    const [checkoutPricesResponse, setCheckoutPricesResponse] = useState<CheckoutPricesResponse>(); // Checkout prices response from PaymentForm.tsx

    const [productCheckoutModel, setProductCheckoutModel] = useState<ProductCheckoutModel>();
    /*     const [activeUntilDate, setActiveUntilDate] = useState<Date>();
        const [availableUntilWeeks, setAvailableUntilWeeks] = useState<number>();
        const [availableUntilMonths, setAvailableUntilMonths] = useState<number>();
     */

    // Invalid field states
    const [invalidFields, setInvalidFields] = useState({
        title: false,
        category: false,
        location: false,
        description: false,
        dayPrice: false,
        availableUntilDate: false,
    })

    const [addCancelRental, setAddCancelRental] = useState(String);

    const [amountOfSubscriptions, setAmountOfSubscriptions] = useState<number>();
    const [amountOfUserProducts, setAmountOfUserProducts] = useState<number>();
    const [isEligibleForCampaign1000, setIsEligibleForCampaign1000] = useState<boolean>(amountOfSubscriptions ? (amountOfSubscriptions < 1000 && amountOfUserProducts === 0) ? true : false : false);

    const fetchProductDetail = async (id: number) => {
        setFormLoading(true);
        const res = await getProductDetailsEdit(id);
        setHighlightUntilDate(res.highlightedUntilDate);

        setItemFields((prevState) => {
            return {
                title: res.title,
                description: res.description,
                location: res.location,
                category: res.category,
                availableUntilDate: prevState.availableUntilDate
            }
        });
        setPrices(res);

        setOriginalActiveUntilDate(new Date(res.productSubscription.activeUntilDate)); // Store original value from the database
        //setOriginalActiveUntilDate(new Date(2024, 4, 10)); // Store original value from the database

        // setItemFields({ ...res, availableUntilDate: new Date(res.productSubscription.activeUntilDate) })

        setProductImages(res.pictures.map((itm, inx) => {
            return {
                inx: inx,
                url: itm.publicUrl,
                fileId: itm.id,
                isMain: itm.orderNr === 0
            }
        }))
        setFormLoading(false);
    }

    const setPrices = (data: ProductEditResponse) => {
        setPriceDay(data.dailyPrice);
        if (data.hourlyPrice) {
            setPriceHour(data.hourlyPrice);
        } else {
            setPriceHour(0);
        }
        if (data.weeklyPrice) {
            setPriceWeek(data.weeklyPrice);
        } else {
            setPriceWeek(0);
        }
        if (data.monthlyPrice) {
            setPriceMonth(data.monthlyPrice);
        } else {
            setPriceMonth(0);
        }
    }

    const handleAddRental = () => {

        ReactGA.event({
            category: 'ItemEditPage',
            action: 'Lisa kuulutus nupp (ilma väljade kontrollita)'
        });

        // TODO: here field checks for valid fields
        setAddCancelRental("add_rental");
    }

    const handleRentalPopup = async (type: String) => {
        // TODO: rendikuulutus postitatud
        if (type == "add") {
            // handleSubmitPost();
            if (!validFields(checkoutPricesResponse?.total === 0)) { setAddCancelRental(""); return }

            ReactGA.event({
                category: 'ItemEditPage',
                action: 'Lisa kuulutus nupp (väljade kontrolliga)'
            });

            // product data
            const data: CreateProductModel = {
                title: itemFields.title,
                description: itemFields.description,
                category: itemFields.category!,
                untilActiveDate: itemFields.availableUntilDate!,
                price: {
                    daily: priceDay,
                    hourly: priceHour > 0 ? priceHour : undefined,
                    weekly: priceWeek > 0 ? priceWeek : undefined,
                    monthly: priceMonth > 0 ? priceMonth : undefined
                },
                location: itemFields.location,
                pictureIds: productImages.map((img) => img.fileId),
                paymentOptionCode: selectedPaymentOption!,
                checkoutOverviewData: {
                    ...checkoutPricesResponse!,
                    boostLevel: boostOption
                },
                checkoutModel: productCheckoutModel!
            };

            if (selectedPaymentOption === "CARD") {
                setTabType(ItemEditPageTabType.PAYMENT);
            } else {
                setFormLoading(true);   
            }
            if (checkoutPricesResponse?.total === 0) {
                setCreatingProductLoading(true);
            }
            setAddCancelRental("")
            setStripeClientSecret(undefined);

            let res: any;
            if (originalActiveUntilDate && originalActiveUntilDate < new Date() && productId !== undefined) {
                // case for extending expired rental's display period, replace subscription for the product
                res = await createPost(data, productId);
            } else {
                // case for creating new rental
                res = await createPost(data, savedProductId, savedOrderId);
            }

            if (res.type === CreateProductResponseType.CARD_PAYMENT) {
                // Initialize a checkout session, this request is made on payment component load so we need to store the product and subscription id 
                // for later if the user wants to edit the product details
                setSavedOrderId(res.orderId);
                setSavedProductId(res.id);
                setStripeClientSecret(res.clientSecret);
            } else if (res.type === CreateProductResponseType.REDIRECT_PAYMENT) {
                // redirect user to the payment url
                setFormLoading(false);
                setRedirectedToPayment(true);
                window.open(res.paymentUrl!, '_blank')?.focus();
            } else if (res.type === CreateProductResponseType.ORDER_CONFIRMED) {
                setFormLoading(false);
                setCreatingProductLoading(false);
                navigate(`/payment?order_id=${res.orderId!.toString()}&payment_type=${PaymentCompletedPagePaymentType.FREE}&visible_until_date=${format(res.visibleUntilDate!, "yyyy-MM-dd'T'HH:mm:ssXXX")}&product_id=${res.id.toString()}`)
            }
        }
        if (type == "cancel") {
            setAddCancelRental("");
            if (editPageType === "create" && !savedProductId) {
                // we don't need to remove product from the database as it was not yet added. We should still delete pictures from aws that user could have added, 
                // hard to do right now as how do we identify these pictures, not associated to any product id
                navigate("/")
            }
            if (productId || savedProductId) {
                // we have already product in the database so we should delte it, also remove pictures in the backend
                let prodId: number | undefined;
                if (productId) {
                    prodId = productId;
                } else if (savedProductId) {
                    prodId = savedProductId;
                }
                if (!prodId) {
                    return;
                }
                if (displayType !== DisplayType.MOBILE) {
                    setFormLoading(true);
                } else {
                    dispatch(setGlobalLoadingState(true));
                }

                try {
                    const res = await deleteProduct(prodId);
                    if (res.status === ProductRemoveStatus.SUCCESS) {
                        dispatch(addNotification({message: "Toode edukalt eemaldatud", type: NotificationType.SUCCESS}));
                        dispatch(setGlobalLoadingState(false));
                        setFormLoading(false);
                        navigate("/")
                    } else {
                        dispatch(setGlobalLoadingState(false));
                        setFormLoading(false);
                        dispatch(addNotification({message: "Tootele on aktiivsed rendid või renditaotlusi tulemas. Veendu et kõik tulevad renditaotlused on tühistatud.", type: NotificationType.ERROR}));
                    }
                } catch (e) {
                    dispatch(setGlobalLoadingState(false));
                    setFormLoading(false);
                    dispatch(addNotification({message: "Toote kustutamine ebaõnnestus.", type: NotificationType.ERROR}));
                }
            }
        }

    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    function validFields(ignorePayment = false) {

        let invalid = false;

        setInvalidFields((prevState) => ({ // Reset invalid states for a new invalid check
            title: false,
            category: false,
            location: false,
            description: false,
            dayPrice: false,
            availableUntilDate: false,
        }));

        if (!addNotification) {
            return false;
        }

        if (!itemFields.title.length || itemFields.title.length > 150) {
            dispatch(addNotification({ message: 'Lisa kuulutusele pealkiri kuni 150 tähemärki!', type: NotificationType.ERROR }))
            setInvalidFields((prevState) => ({ ...prevState, title: true }));  // Use prevState to ensure you're not overwriting other fields
            console.log(invalidFields.title);  // This will still log `false` due to async nature
            invalid = true;
        }
        if (!itemFields.category) {
            dispatch(addNotification({ message: 'Määra kuulutusele kategooria.', type: NotificationType.ERROR }))
            setInvalidFields((prevState) => ({ ...prevState, category: true }));
            invalid = true;
        }
        if (!itemFields.location.length || itemFields.location.length > 150) {
            dispatch(addNotification({ message: 'Lisa kuulutusele asukoht kuni 150 tähemärki.', type: NotificationType.ERROR }))
            setInvalidFields((prevState) => ({ ...prevState, location: true }));
            invalid = true;
        }
        if (!itemFields.description.length || itemFields.description.length > 500) {
            dispatch(addNotification({ message: 'Lisa kuulutusele kirjeldus kuni 500 tähemärki!', type: NotificationType.ERROR }))
            setInvalidFields((prevState) => ({ ...prevState, description: true }));
            invalid = true;
        }
        if (!priceDay || priceDay === 0) {
            dispatch(addNotification({ message: 'Kuulutusele peab olema määratud päevahind!', type: NotificationType.ERROR }))
            setInvalidFields((prevState) => ({ ...prevState, dayPrice: true }));
            invalid = true;
        }
        if (!itemFields.availableUntilDate || itemFields.availableUntilDate < new Date()) {
            dispatch(addNotification({ message: 'Kuulutusele peab olema määratud pakett/lõpukuupäev!', type: NotificationType.ERROR }))
            setInvalidFields((prevState) => ({ ...prevState, availableUntilDate: true }));
            invalid = true;
        }
        if (ignorePayment === false) {
            if (!selectedPaymentOption || (selectedPaymentOption && !selectedPaymentOption.length)) {
                dispatch(addNotification({ message: 'Vali maksemeetod.', type: NotificationType.ERROR }))
                invalid = true;
            }
        }
        if (productImages.length < 1) {
            dispatch(addNotification({ message: 'Kuulutusele peab lisama vähemalt ühe pildi.', type: NotificationType.ERROR }))
            invalid = true;
        }

        if (!productCheckoutModel) {
            return false;
        }

        if (invalid) { return false }

        return true;
    }

    function getPriceValue(price_opt: number): number | undefined {
        if (!priceValues.find((itm) => itm.id === price_opt)) {
            return undefined;
        }
        return priceValues.find((itm) => itm.id === price_opt)!.type
    }

    function handlePriceValTypeUpdate(id: number, val: RENT_PRICE_OPTION, amount?: number) {
        const inx = priceValues.findIndex((itm) => itm.id === id)
        if (inx === -1) {
            return undefined;
        }
        if (priceValues.filter((itm) => (!getIsMulti(itm.type) && itm.type === val) || (getIsMulti(itm.type) && itm.type === val && itm.amount === amount)).length > 1) {
            return;
        }
        const prevPriceVals = [...priceValues]
        if (!multiPriceOptions.includes(val)) {
            prevPriceVals.splice(inx, 1, { ...priceValues[inx], type: val })
        } else {
            prevPriceVals.splice(inx, 1, { ...priceValues[inx], type: val, amount: 1 })
        }
        setPriceValues([...prevPriceVals]);
    }

    function handlePriceValAtrUpdate(id: number, atr: keyof RentPriceValues, val: any) {
        const inx = priceValues.findIndex((itm) => itm.id === id)
        if (inx === -1) {
            return undefined;
        }
        const prevPriceVals = [...priceValues]
        prevPriceVals.splice(inx, 1, { ...priceValues[inx], [atr]: val })
        setPriceValues([...prevPriceVals]);
    }

    function getIsMulti(type: RENT_PRICE_OPTION) {
        return multiPriceOptions.includes(type);
    }

    function handleAddPriceOption() {
        let newType = getMoreTypesToAdd();
        if (!newType.length) {
            newType = [RENT_PRICE_OPTION.HOURS];
        }
        const newOption: RentPriceValues = {
            id: inx + 1,
            type: newType[0],
            price: 0
        }
        if (getIsMulti(newType[0])) {
            newOption.amount = 1;
        }
        setInx(inx + 1);
        setPriceValues([...priceValues, newOption])
    }

    function getMoreTypesToAdd(): RENT_PRICE_OPTION[] {
        const allTypes: number[] = (Object.keys(RENT_PRICE_OPTION).filter((item) => {
            return !Number.isNaN(Number(item));
        })).map((itm) => Number(itm));
        const usedTypes = priceValues.map((itm) => itm.type);
        const typesToAdd = []

        for (const type of allTypes) {
            if (!usedTypes.includes(type)) {
                typesToAdd.push(type);
            }
        }

        return typesToAdd;
    }

    function getRemainingTypeOptions(type: RENT_PRICE_OPTION) {
        const remainingTypes = getMoreTypesToAdd();

        return rentPriceTypeOptions.filter((opt) => remainingTypes.includes(opt.val) || getIsMulti(opt.val) || opt.val === type);
    }

    function removePriceOption(id: number) {
        const inx = priceValues.findIndex((itm) => itm.id === id)
        if (inx === -1) {
            return undefined;
        }
        const prevPriceVals = [...priceValues]
        prevPriceVals.splice(inx, 1)
        setPriceValues([...prevPriceVals]);
    }

    const handleCategorySelect = (v: ProductCategory[]) => {
        // let categoryEnum: ProductCategory | undefined = ProductCategory.HOME;
        // let value = "";
        // if (v.length) {
        //     value = v[0];
        // } else {
        //     setItemFields({ ...itemFields, category: undefined })
        //     return;
        // }
        // switch (value) {
        //     case "transportation":
        //         categoryEnum = ProductCategory.TRANSPORTATION;
        //         break;
        //     case "tools":
        //         categoryEnum = ProductCategory.TOOLS;
        //         break;
        //     case "leisure":
        //         categoryEnum = ProductCategory.LEISURE;
        //         break;
        //     default:
        //         categoryEnum = ProductCategory.HOME;
        //         break;
        // }
        setItemFields({ ...itemFields, category: v.length ? v[0] : undefined })
        //setCategory(categoryEnum);
    }

    const navigateToPaymentUrl = (paymentUrl: string) => {
        window.open(paymentUrl, "_blank");
    };

    const handleUpdateProduct = async () => {

        if (!validFields(true)) { return }

        setFormLoading(true);

        const data: UpdateProductModel = {
            title: itemFields.title,
            description: itemFields.description,
            // category: itemFields.category, shouldn't allow editing category rn while user payed for certain category. Later should allow this option and maybe add extra payment
            price: {
                daily: priceDay,
                hourly: priceHour > 0 ? priceHour : undefined,
                weekly: priceWeek > 0 ? priceWeek : undefined,
                monthly: priceMonth > 0 ? priceMonth : undefined
            },
            location: itemFields.location,
            pictureIds: productImages.map((img) => img.fileId)
        };

        const res = await updateProduct(data, productId!);
        setUpdateSuccess(true);
        setFormLoading(false);
    }

    useEffect(() => {
        fetchAmountOfSubscriptions();
        fetchAmountOfUserProducts();
    }, [])

    useEffect(() => {
        setIsEligibleForCampaign1000(amountOfSubscriptions ? (amountOfSubscriptions < 1000 && amountOfUserProducts === 0) ? true : false : false);
    }, [amountOfSubscriptions, amountOfUserProducts])
    
    const fetchAmountOfSubscriptions = async () => {
        const res = await getTotalAmountOfSubscriptions();
        setAmountOfSubscriptions(res);
    }
    const fetchAmountOfUserProducts = async () => {
        if (user) {
            // const res = await getUserProducts(user?.id, { skip: 0, take: 0 });
            const res = await getUserSubscriptionsCount(user.id);
            setAmountOfUserProducts(res);
        }
    }

    const campaign1000Content: React.ReactNode = (
        <div className="ml-6 pl-6 border-l-[1px] border-primary/60">
            <h2 className="text-primary">Kampaania</h2>
            <div>Piiratud koguses kuulutusi kogu platvormi peale</div>
        </div>
    )

    const handleUntilPlanChange = (option: string) => {
        setProductUntilOption(parseInt(option));
        setProductCheckoutModel({ ...productCheckoutModel, boostLevel: boostOption })
    }

    useEffect(() => {
        console.log("HEREE")
        // Update data for order overview refresh
        const newCheckoutData = {...productCheckoutModel};

         newCheckoutData.availableUntilDate = itemFields.availableUntilDate;
         newCheckoutData.boostLevel = boostOption;
         newCheckoutData.priceDay = priceDay;
         newCheckoutData.category = itemFields.category;

        if (useExactUntilDate) {
            newCheckoutData.availableUntilDate = itemFields.availableUntilDate;
            newCheckoutData.availableUntilWeeks = undefined;
        } else {
            // setProductCheckoutModel((prevState) => ({ ...prevState, availableUntilDate: undefined }))
            newCheckoutData.availableUntilDate = undefined;
            // Find the selected productUntilOption and assign weeks/months
            const selectedOption = productUntilOptions.find(option => option.value === productUntilOption?.toString());
            const availableUntilWeeks = selectedOption?.data.weeks || undefined;
            newCheckoutData.availableUntilWeeks = availableUntilWeeks;
            console.log("update until active data");
            setItemFields((prevState) => ({ ...prevState, availableUntilDate: availableUntilWeeks ? addWeeks(new Date(), availableUntilWeeks) : undefined }))
        }

        setProductCheckoutModel((prevState) => {
            return {
                ...prevState,
                ...newCheckoutData
            }
        })
    }, [useExactUntilDate, itemFields.dayPrice, boostOption, useExactUntilDate, productUntilOption, priceDay, itemFields.category])

    useEffect(() => {
        console.log("HEREE2", itemFields);
        setProductCheckoutModel((prevState) => ({ ...prevState, availableUntilDate: itemFields.availableUntilDate }));
    }, [itemFields.availableUntilDate])

    const productUntilOptions: DropdownOptionItem[] = [
        {
            value: "0",
            label: '1 nädal',
            extraLabel: isEligibleForCampaign1000 ? "PRAEGU TASUTA" : "",
            data: {
                weeks: 1
            }
        },
        {
            value: "1",
            label: '2 nädalat',
            extraLabel: isEligibleForCampaign1000 ? "PRAEGU TASUTA" : "",
            data: {
                weeks: 2
            }
        },
        {
            value: "2",
            label: '1 kuu',
            extraLabel: isEligibleForCampaign1000 ? "PRAEGU TASUTA" : "",
            data: {
                weeks: 4
            }
        },
        {
            value: "3",
            label: '3 kuud',
            extraLabel: "Tavahinnast -20%",
            data: {
                weeks: 4 * 3
            }
        },
        {
            value: "4",
            label: '6 kuud',
            extraLabel: "Tavahinnast -30%",
            data: {
                weeks: 6 * 4
            }
        },

    ];
    const boostOptions: DropdownOptionItem[] = [
        {
            value: "1",
            label: '1 nädalaks',
            extraLabel: "5 €",
        },
        {
            value: "2",
            label: '1 kuuks',
            extraLabel: "15 €"
        },

    ];

    return (
        <div className="relative flex flex-col items-baseline">
            <Helmet>
                <title>Rentic - Muuda Kuulutust</title>
                <meta name="description" content="Muuda oma rendikuulutust Renticus" />
                <meta name="keywords" content="rentic, muuda kuulutust, rendiandmete muutmine" />
                <meta property="og:image" content="https://rentic.ee/logo192.png" />
                <meta property="og:url" content="https://rentic.ee/edit" />
            </Helmet>
            {formLoading &&
                <div className="absolute z-30 h-full w-full">
                    <div className="sticky top-1/2 transform -translate-y-1/2 z-10">
                        {editPageType === "create" && !creatingProductLoading &&
                            <div className="p-3">
                                <AccountBalanceOutlinedIcon style={{ width: "60px", height: "60px" }} className="text-gray-500" />
                                <div>Teid suunatakse edasi maksehaldurile</div>
                            </div>
                        }
                        {editPageType === "create" && creatingProductLoading &&
                            <div className="p-3">
                                <HandymanIcon style={{ width: "60px", height: "60px" }} className="text-gray-500" />
                                <div>Toote lisamine</div>
                            </div>
                        }
                        <Spinner size="small" />
                    </div>
                    <div className="absolute top-0 w-full h-full bg-primary_light opacity-50 rounded-xl">
                    </div>
                </div>
            }
            {redirectedToPayment &&
                <div className="absolute z-30 h-full w-full py-10">
                    <div className="sticky top-1/2 transform -translate-y-1/2 z-10">
                        <div className="p-3 flex flex-row items-center w-full justify-center gap-2">
                            <CheckCircleOutlineOutlinedIcon style={{ width: "40px", height: "40px" }} className="text-green-500" />
                            Maksehaldurile suunatud
                        </div>
                    </div>
                    <div className="absolute top-0 w-full h-full bg-primary_light opacity-50 rounded-xl">
                    </div>
                </div>
            }
            {/* Item attributes page */}
            {
                tabType === ItemEditPageTabType.EDIT &&
                <div className="relative flex flex-col pt-[50px] items-baseline w-full">
                    {editPageType === "create" && <h3 className="mb-3">Uus kuulutus</h3>}
                    {editPageType === "edit" && <h3>Kuulutuse muutmine</h3>}
                    {postCreateSuccess &&
                        <div className="fixed top-[100px] w-[200px] rounded-lg border border-green-500 left-10 z-30 bg-white py-2 font-semibold">
                            Edukalt lisatud
                        </div>
                    }
                    {((editPageType === "edit") && originalActiveUntilDate && (originalActiveUntilDate >= new Date())) &&
                        <InlineInfoBox type={"alert"} text={"Oled hetkel muutmas kehtiva kuulutuse andmeid."} />
                    }
                    {editPageType === "edit" && originalActiveUntilDate && originalActiveUntilDate < new Date()
                        &&
                        <InlineInfoBox type={"alert"} text={"Kuulutus on aegunud. Uuenda lõpukuupäeva ja " +
                            "makseandmeid, et see uuesti aktiveerida."} />
                    }
                    {updateSuccess &&
                        <InlineInfoBox type={"success"} text={"Kuulutus edukalt uuendatud"} />
                    }

                    <div className="flex flex-col gap-4 w-full rounded-xl shadow-main p-1 lg:p-6" onClick={() => setUpdateSuccess(false)}>

                        <div className="flex flex-col lg:flex-row p-2 pt-4 gap-8 lg:gap-12">
                            <div className="basis-1/2 flex flex-col gap-4 w-full text-left">
                                <div className="flex flex-col gap-2">
                                    <h4 className="text-left">Pealkiri</h4>
                                    <Input value={itemFields.title} placeHolder="Toode" onChange={(v) => setItemFields({ ...itemFields, title: v })} invalid={invalidFields.title} />
                                </div>

                                <div className="flex flex-col gap-2">
                                    <h4>Kategooria</h4>
                                    {
                                        editPageType === "edit" && itemFields.category ?
                                        <div className="shadow-md text-primary w-fit p-2 rounded-lg">{productCategoryLabelFormatter(itemFields.category, true)}</div>
                                        :
                                        <Dropdown selectedFilterOptions={itemFields.category ? [itemFields.category] : []} options={productCategoryOptions} onSelect={(s) => { handleCategorySelect(s as ProductCategory[]) }} invalid={invalidFields.category} />
                                    }

                                </div>

                                <div className="flex flex-col gap-2">
                                    <h4 className="text-left">Asukoht</h4>
                                    <Input value={itemFields.location} placeHolder="Tallinn" onChange={(v) => setItemFields({ ...itemFields, location: v })} invalid={invalidFields.location} />
                                </div>

                                <div className="flex flex-col gap-2">
                                    <h4>Kirjeldus</h4>
                                    <TextArea value={itemFields.description} onChange={(v) => setItemFields({ ...itemFields, description: v })} invalid={invalidFields.description} />

                                </div>
                                <div className="flex flex-col gap-2">
                                    <div className="flex flex-row items-center gap-1">
                                        <h4>Hinnad</h4>
                                        <Tooltip title="Määrata saab oma esemele erinevaid hindu. Tänu sellele on huvilistel võimalik rentida ka 1 päeva asemel näiteks nädalate kaupa, millele saab rakenduda teistsugune hind. Mõnda esemet võidakse rentida näiteks mitu kuud. Sellisel juhul võib olla mõisltikum määrata kuuhind." arrow>
                                            <InfoIcon className="cursor-pointer text-blue-500" style={{ width: '18px', height: '18px' }} />
                                        </Tooltip>
                                    </div>

                                    <div className="flex flex-row gap-4 max-w-[560px]">
                                        <div>
                                            <Label value={"Päev"} required={true} />
                                            <NumberInput placeHolder="Päeva hind" onChange={(v) => setPriceDay(v)} val={priceDay} minVal={0.00} invalid={invalidFields.dayPrice} />
                                        </div>
                                        <div>
                                            <Label value={"Tund"} />
                                            <NumberInput placeHolder="Päeva hind" onChange={(v) => setPriceHour(v)} val={priceHour} minVal={0.00} />
                                        </div>
                                        <div>
                                            <Label value={"Nädal"} />
                                            <NumberInput placeHolder="Päeva hind" onChange={(v) => setPriceWeek(v)} val={priceWeek} minVal={0.00} />
                                        </div>
                                        <div>
                                            <Label value={"Kuu"} />
                                            <NumberInput placeHolder="Päeva hind" onChange={(v) => setPriceMonth(v)} val={priceMonth} minVal={0.00} />
                                        </div>
                                    </div>
                                    {
                                        editPageType === "edit" && originalActiveUntilDate &&
                                        <div className="flex flex-col pt-2">
                                            <h4>Nähtaval kuni</h4>
                                            <div className="flex flex-row gap-1 pt-1">
                                                <CalendarMonthOutlinedIcon style={{width: "20px", height: "20px"}}/>
                                                <div>{format(originalActiveUntilDate, "dd. MMM, yyyy", {locale: et})}</div>
                                            </div>
                                        </div>
                                    }

                                    { editPageType === "edit" && highlightUntilDate &&
                                        <div className="flex flex-col pt-2">
                                            <div className="flex flex-row">
                                                <h4>Esiletõstetud kuni </h4>
                                                <img src={crownIcon} className='w-[20px] h-[20px] ml-2'/>
                                            </div>
                                        <div className="flex flex-row gap-1 pt-1">
                                        <CalendarMonthOutlinedIcon style={{width: "20px", height: "20px"}}/>
                                        <div>{format(highlightUntilDate, "dd. MMM, yyyy", {locale: et})}</div>
                                        </div>
                                    </div>
                                    }
                                </div>
                                {/* <div className="flex flex-col items-baseline">
                                    {itemFields.availableUntilDate && itemFields.availableUntilDate < new Date() &&
                                        <InlineInfoBox type={"error"} text={"Lõpukuupäev on möödunud."} />
                                    }
                                    <h4>Kuupäevad</h4>
                                    <div className="flex flex-col">
                                        {editPageType == "create" || (itemFields.availableUntilDate && itemFields.availableUntilDate < new Date()) || (editPageType == "edit" && originalActiveUntilDate && originalActiveUntilDate < new Date()) ?
                                            <div className="flex flex-col">
                                                <Label value={"Määra kuulutusele automaatne lõpukuupäev"} />
                                                <div className="max-w-[200px]">
                                                    <DatePickerComponent disablePastDates={true} mode={"single"} dateChanged={(d) => { console.log("set date ", d); setItemFields({ ...itemFields, availableUntilDate: d }) }} initialValue={itemFields ? itemFields.availableUntilDate : undefined} />
                                                </div>
                                            </div>
                                            :
                                            <div>
                                                <Label value={"Kuulutus on aktiivne kuni"} />{
                                                    itemFields.availableUntilDate ?
                                                        <span>{format(itemFields.availableUntilDate!, 'dd.MM.yyyy')}</span>
                                                        :
                                                        <></>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div> */}

                                {/* <div className="flex flex-col">
                                <div className="flex flex-row items-center gap-1">
                                    <h4>Mitu eset</h4>
                                    <Tooltip title="Kui sama eset on rentida mitu tükki, siis saab siin seda määrata. Igale esemele rakendub eraldi saadavuskalender. Esemed peavad olema tööpõhimõttelt ikkagi samad. Esemete arv ei mõjuta kuulutuse paiknemist Renticu lehel." arrow>
                                        <InfoIcon className="cursor-pointer text-blue-500" style={{ width: '18px', height: '18px' }} />
                                    </Tooltip>
                                </div>
                                <div className="flex flex-col">
                                    <div className="flex flex-row gap-4 align-middle items-center pt-1 pl-1">
                                        <Label value={"Mul on sama eset mitu tükki, mida soovin välja rentida"} />
                                        <Switch
                                            checked={multipleItemsSwitch}
                                            onChange={() => setMultipleItemsSwitch(!multipleItemsSwitch)}
                                        />
                                    </div>
                                    <div>
                                        {multipleItemsSwitch ?
                                            <div className="max-w-[200px]">
                                                <NumberInput placeHolder="Esemete arv" onChange={(v) => setMultipleItemsAmount(v)} val={multipleItemsAmount} minVal={2} />
                                            </div> : ""}
                                    </div>
                                </div>

                            </div> */}

                                {/* <div className="w-full flex flex-row gap-2">
                                <div className="w-full lg:w-[40%]">
                                    <h4>Hinnad</h4>
                                    <div className="flex flex-row gap-3">

                                    </div>
                                    <div className="w-full">
                                        {priceValues.map((it) => {
                                            return <div className="flex flex-row gap-2 items-end">
                                                <div className="flex-1">
                                                </div>
                                                {getIsMulti(it.type) &&
                                                    <div className="flex-1">
                                                        <label>Arv</label>
                                                        <NumberInput placeHolder="arv" onChange={(v) => handlePriceValAtrUpdate(it.id, 'amount', v)} val={it.amount!} minVal={1} />
                                                    </div>
                                                }
                                                <div className="flex-1">
                                                    <label>Tüüp</label>
                                                    <DropdownSelect opetions={getRemainingTypeOptions(it.type)} value={getPriceValue(it.id)} optionSelected={(v) => handlePriceValTypeUpdate(it.id, v as RENT_PRICE_OPTION, it.amount)} />
                                                </div>
                                                <div className="flex-none group cursor-pointer" onClick={() => removePriceOption(it.id)}>
                                                    <div className="px-2 py-2 group-hover:bg-red-500 w-fit transition-colors duration-300 rounded-md">
                                                        <DeleteOutlineOutlinedIcon style={{ width: "26px", height: "26px" }} className="text-red-500 group-hover:text-white" />
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                        <div className="mt-2">
                                            <PrimaryButton icon={<AddOutlinedIcon style={{ width: "26px", height: "26px" }} />} onClick={handleAddPriceOption} title="Lisa hind" outlined={true} />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="w-full lg:w-[60%]">
                                    <label>Rendiperioodid</label>
                                    <RentDateSelection />
                                </div> </div>*/
                                }

                            </div>
                            <div className="basis-1/2 lg:max-w-[50%] flex flex-col gap-6 text-left overflow-hidden">

                                <div className="flex flex-col gap-2 w-full">
                                    <h4>Lisa vähemalt üks pilt</h4>
                                    <div className="flex flex-row text-sm text-gray-600"><div className="text-primary">*</div>pilt suuruses kuni 20MB, formaat png, jpeg, jpg, heif, webp</div>
                                    <ImageFileUploadCard maxFilesAmount={7} handleFilesChanged={(pics) => setProductImages([...pics])}
                                        pictureFiles={productImages} />
                                </div>
                            </div>
                        </div>
                    </div>



                    {(editPageType === "create" || (originalActiveUntilDate && originalActiveUntilDate < new Date())) &&
                        <>

                            <h3 className="mt-4">Kuulutuse aeg</h3>
                            <div className="flex flex-col lg:flex-row gap-4 w-full rounded-xl shadow-main p-2 lg:p-6" onClick={() => setUpdateSuccess(false)}>

                                <div className="flex flex-col lg:flex-row p-2 pt-4 gap-8 lg:gap-12">
                                    <div className="flex flex-col gap-4 w-full text-left">



                                        <div className="flex flex-col">
                                            <div className="flex flex-row items-center gap-1">
                                                <h4>Hoia kuulutust üleval</h4>
                                                <Tooltip title="Hind arvutatakse täiskuude ja -nädalate põhiselt." arrow>
                                                    <InfoIcon className="cursor-pointer text-blue-500" style={{ width: '18px', height: '18px' }} />
                                                </Tooltip>
                                            </div>
                                            <div className="flex flex-col gap-2 pt-2">


                                                <div>
                                                    {useExactUntilDate ?
                                                        <DatePickerComponent placeholder="Vali täpne kuupäev" disablePastDates={true} mode={"single"} dateChanged={(d) => { console.log("set date ", d); setItemFields({ ...itemFields, availableUntilDate: d }) }} initialValue={itemFields.availableUntilDate ? itemFields.availableUntilDate : undefined} />
                                                        :
                                                        <Dropdown options={productUntilOptions} selectedFilterOptions={productUntilOption !== undefined ? [productUntilOption.toString()] : []} placeholder='Vali pakett' onSelect={(o) => { (o && o.length) ? handleUntilPlanChange(o[0]) : setProductUntilOption(undefined) }} isMultiSelect={false} />
                                                    }
                                                </div>
                                                <div className="flex flex-row gap-2 align-middle items-center pt-1 pl-1">
                                                    <Label value={"Valin paketi asemel täpse kuupäeva"} />
                                                    <Switch
                                                        checked={useExactUntilDate}
                                                        onChange={() => setUseExactUntilDate(!useExactUntilDate)}
                                                    />
                                                    {/* {JSON.stringify(productCheckoutModel)} */}
                                                </div>
                                                {
                                                    !useExactUntilDate && itemFields.availableUntilDate &&
                                                    <div> Kuvatakse kuni: {format(itemFields.availableUntilDate,
                                                        "dd. MMM, yyyy", {locale: et})}</div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-col p-2 lg:ml-6 lg:pl-6 lg:border-l-[1px] border-primary/60">
                                    <h3 className="text-primary text-left pb-4">Kuulutuse esiletõstmine</h3>
                                    <div className='flex flex-col gap-1 w-[250px] text-[15px] font-light'>
                                        <Dropdown label='Näita kuulutust pealehel esimeste seas?' options={boostOptions} selectedFilterOptions={boostOption ? [boostOption.toString()] : []} placeholder='Vali pakett' onSelect={(o) => { (o && o.length) ? setBoostOption(parseInt(o[0])) : setBoostOption(undefined) }} isMultiSelect={false} />
                                    </div>
                                </div>
                            </div>
                            <div className="relative flex flex-col gap-4 w-full text-left bg-white pt-4">
                                <PaymentForm checkoutData={productCheckoutModel} paymentOptionChanged={(v) => setSelectedPaymentOption(v)} 
                                campaign1000={isEligibleForCampaign1000} setCheckoutPricesResponse={setCheckoutPricesResponse} 
                                discountCodeApplied={(v) => v && setProductCheckoutModel({...productCheckoutModel, discountCode: v.code, discountCodeId: v.discountCodeId})}/>
                            </div>
                        </>
                    }
                </div>
            }
            {/* Payments page */}
            {
                tabType === ItemEditPageTabType.PAYMENT &&
                <div className="w-full flex justify-center">
                    {(loadingPaymentSession || !stripeClientSecret) ?
                        <div className="mt-8">
                            <Spinner />
                        </div>
                        :
                        <div className="w-full">
                            <EmbeddedCheckoutProvider
                                stripe={stripePromise}
                                options={{ clientSecret: stripeClientSecret }}
                            >
                                <EmbeddedCheckout />
                            </EmbeddedCheckoutProvider>
                        </div>
                    }
                </div>
            }
            {/* Notification Hub is passed the function to add notifications */}
            <div className="w-full mt-6">
                <div>
                    <div className="pt-2 w-full flex flex-row lg:flex-row gap-2 justify-between">
                        <div className="w-full flex flex-row lg:w-[400px]">

                            {(editPageType === "create") ?
                                <div className="flex flex-row w-full gap-4 lg:max-w-[200px]">
                                    {
                                        tabType === ItemEditPageTabType.EDIT ?
                                            <PrimaryButton onClick={() => { handleAddRental() }}
                                                // title={amountOfProducts ? amountOfProducts < 1000 ? "Lisa kuulutus" : "Maksma" : "Maksma"} 
                                                title={isEligibleForCampaign1000 ? "Lisa kuulutus" : "Maksma"}
                                            />
                                            :
                                            <PrimaryButton onClick={() => { setTabType(ItemEditPageTabType.EDIT) }} title={"Tagasi muutma"} />
                                    }
                                    {/* <PrimaryButton outlined={true} onClick={() => { handleAddRental() }} title="Salvesta kuulutus" /> */}
                                </div>
                                :
                                <div className="flex flex-row gap-2 w-full">
                                    <div className="w-1/2">
                                        <PrimaryButton onClick={() => { handleUpdateProduct() }} title="Salvesta" />
                                    </div>
                                    {
                                        editPageType === "edit" && originalActiveUntilDate && originalActiveUntilDate < new Date() &&
                                        productCheckoutModel?.availableUntilDate &&
                                        isAfter(productCheckoutModel.availableUntilDate, new Date()) &&
                                        <div className="w-1/2">
                                            <PrimaryButton onClick={() => { setAddCancelRental("add_rental") }}
                                                           title="Pikenda tellimust" />
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        <div className="w-full flex flex-row justify-end lg:w-[200px]">
                            <div className="w-[166  px]">
                                <DeleteButton onClick={() => { setAddCancelRental("cancel_rental") }} 
                                title= {(editPageType === "create" && !savedProductId) ? "Loobu kuulutusest" : "Kustuta kuulutus"} outlined={true} />
                            </div>
                        </div>
                        {addCancelRental == "add_rental" ?
                            <Popup
                                message="Kas postitada rendikuulutus?"
                                onConfirm={() => { handleRentalPopup("add") }}
                                onCancel={() => { setAddCancelRental("") }}
                            />
                            : addCancelRental == "cancel_rental" ?
                                <Popup
                                    message="Kas oled kindel, et loobuda sellest rendikuulutusest?"
                                    onConfirm={() => { handleRentalPopup("cancel") }}
                                    onCancel={() => { setAddCancelRental("") }}
                                /> : ""}
                    </div>
                </div>
            </div>

        </div>)
};